<div class="mt-5">
    <div fxLayout="column">
        <div class="col-md-12">
            <span evkMatHeadLine>Confirmación de correo electrónico</span>
        </div>
        <div fxLayout="column">
            <div class="col-md-12">
                <span class="mat-subheading-1 mat-body-strong ng-star-inserted">Ingresar su código de confirmación (6 dígitos)</span>
            </div>
            <form [formGroup]="this.validacionCodigoForm">
                <mat-form-field appearance="outline" fxFlex="50%">
                    <mat-label>Código de confirmación</mat-label>
                    <input validatedNumber
                           matInput
                           [maxLength]="6"
                           [minlength]="6"
                           [readonly]="this.readonly"
                           type="text"
                           cleanWhiteSpace
                           formControlName="codigoValidacion"
                           [required]="true">
                    <mat-spinner *ngIf="this.showSpinner" class="icon-size-5" matSuffix></mat-spinner>

                    <mat-icon *ngIf="this.showValidIcon"
                              class="icon-size-5"
                              matSuffix
                              [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>

                    <mat-icon *ngIf="this.showInvalidIcon"
                              class="icon-size-5"
                              matSuffix
                              [svgIcon]="'heroicons_solid:x-circle'"></mat-icon>

                </mat-form-field>
            </form>
        </div>
    </div>

</div>
